import { useEffect } from 'react';
import RestUtilities from '../../services/RestUtilities';

import { not } from '../../Functions';
import { Box, Typography } from '@mui/material';
import AddRemoveArtist from '../../components/Common/AddRemoveArtist';
import {
  liveArtistsState,
  loadingState,
  stylesState,
  toastState,
} from '../../state/RecoilState';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useGetLiveArtists } from '../../hooks/useGetLiveArtists';

const Styles = () => {
  const setLoading = useSetRecoilState(loadingState);
  const setToast = useSetRecoilState(toastState);
  const [liveArtists, setLiveArtists] = useRecoilState(liveArtistsState);
  const [styles, setStyles] = useRecoilState(stylesState);
  useEffect(() => {
    const getAllData = async () => {
      setLoading(true);
      const res = await RestUtilities.get('/api/styles/Get');
      setStyles(res.content);
      setLoading(false);
    };
    if (!styles) {
      getAllData();
    }
  }, [setLoading, setStyles, styles]);

  useGetLiveArtists();

  const updateStyleGroup = async (styleId, newGroup) => {
    setLoading(true);
    const existingGroup = liveArtists.filter((x) =>
      x.artistStyles.some((c) => c.styleId === styleId)
    );
    const added = not(newGroup, existingGroup);
    const removed = not(existingGroup, newGroup);
    const artistsToUpdate = [];
    added.forEach((element) => {
      const found = liveArtists.find((x) => x.artistId === element.artistId);
      const artistToAdd = { ...found };
      artistToAdd.artistStyles = [
        ...artistToAdd.artistStyles,
        { styleId, artistId: element.artistId },
      ];
      artistsToUpdate.push(artistToAdd);
    });
    removed.forEach((element) => {
      const found = liveArtists.find((x) => x.artistId === element.artistId);
      const artistToRemove = { ...found };
      const newStyles = artistToRemove.artistStyles.filter(
        (x) => x.styleId !== styleId
      );
      artistToRemove.artistStyles = newStyles;
      artistsToUpdate.push(artistToRemove);
    });
    if (artistsToUpdate.length) {
      var resp = await RestUtilities.put(
        `/api/artist/UpdateStyles`,
        artistsToUpdate
      );
      const updated = resp.content;
      const newLiveArtists = liveArtists.filter(
        (x) => !updated.some((c) => c.artistId === x.artistId)
      );
      updated.forEach((a) => {
        newLiveArtists.push(a);
      });
      newLiveArtists.sort((a, b) => a.artistName.localeCompare(b.artistName));
      setLiveArtists(newLiveArtists);
      setToast('Styles Updated');
      setLoading(false);
    }
  };

  return (
    <Box pt={1}>
      {styles?.map((s) => {
        return (
          <Box key={`${s.styleId}`} sx={{ width: '100%', mb: 4 }}>
            <Typography
              variant='h5'
              color='primary'
              style={{ textAlign: 'left' }}
            >
              <span
                style={{ textTransform: 'capitalize' }}
              >{`${s.styleName}`}</span>
            </Typography>
            <AddRemoveArtist
              left={liveArtists}
              right={liveArtists.filter((x) =>
                x.artistStyles.some((c) => c.styleId === s.styleId)
              )}
              setRight={(list) => updateStyleGroup(s.styleId, list)}
              leftTitle='Unassigned'
              rightTitle={`In ${s.styleName}`}
            />
          </Box>
        );
      })}
    </Box>
  );
};
export default Styles;
